import { Flex, Text } from '@radix-ui/themes';
import React from 'react';
import CreditCardSelectExpiryText from './CreditCardSelectExpiryText';
import { toTitleCase } from '@/lib/utils';
import CreditCardSelectImage from './CreditCardSelectImage';
import { TokenizedPM } from '@/lib/interface/stripe/tokenizedCard';
import { isLink, MinimalCard } from '@/lib/interface/stripe/BiddifyPaymentMethod';

const PaymentMethodSelectItem = ({ paymentMethod }: { paymentMethod: TokenizedPM }) => {
  return (
    <Flex className="rounded-md" align="center">
      <CreditCardSelectImage card={paymentMethod} />
      <Flex direction="column" className="w-fit ml-3" align="start">
        {isLink(paymentMethod) ?
          <Text className="text-sm text-foreground">{paymentMethod.email}</Text> :
          <Flex direction="column" align="start">
            <Text className="text-sm text-foreground">{toTitleCase(paymentMethod.brand)} ending in {paymentMethod.last4}</Text>
            <CreditCardSelectExpiryText card={paymentMethod as MinimalCard} />
          </Flex>
        }
      </Flex>
    </Flex>
  )
}

export default PaymentMethodSelectItem;  
